import { Model } from "./";
import { Api } from "../api";

class SectionModel extends Model {
  constructor() {
    super(new Api("/section"));
  }

  getList(data, thenFunction, errorFunction) {
    this.q.setDopUrl("/list");
    this.q.read(data, thenFunction, errorFunction);
  }

  getAllSection(clientId, thenFunction, errorFunction) {
    this.q.setDopUrl("/list");
    let data = {
      json: {
        limit: 500,
        fields: ["id", "code", "name", "ex_id"],
        sort: {
          orderField: "name",
          orderBy: "ASC",
        },
        filter: {
          blockId: 1,
          ex_id: [
            "d638ec4e-ca79-11eb-b417-005056011f71",
            "e1a546fb-ca79-11eb-b417-005056011f71",
            "08e85403-ca7a-11eb-b417-005056011f71",
            "3ee2be2d-ca7a-11eb-b417-005056011f71",
            "1df00895-ca7a-11eb-b417-005056011f71",
            "220e25af-980f-11ee-b4e8-005056011f71",
            "c089c1b0-593f-11ef-b51d-005056011f71",
            "6b91b51b-fccb-11ee-b506-005056011f71", //БАДы
          ],
        },
        clientId: clientId,
      },
    };
    this.q.read(data, thenFunction, errorFunction);
  }
}

export default new SectionModel();
